<template>
    <v-dialog v-model="getModalEnviarEmailOrcamento" max-width="720px" transition="dialog-transition">
        <v-card outlined>
            <v-card-title>Enviar orçamento por e-mail</v-card-title>
            <v-form ref="form" class="px-3">
            <v-card-text :loading="$store.getters.getOverlay">
                    <v-layout row wrap>
                        <v-flex xs12 md12>
                            <v-select
                                :items="tiposImpressao"
                                v-model="tipoImpressao"
                                item-text="label"
                                item-value="value"
                                label="Modelo"
                                outlined
                                dense
                                :rules="rules.tipoImpressao"
                                class="mr-2 ml-2"
                            ></v-select>
                        </v-flex>
                        <v-flex xs12 md12>
                            <v-text-field
                                label="E-mail"
                                v-model="email"
                                outlined
                                dense
                                :rules="rules.email"
                                class="mr-2 ml-2" 
                                @keyup.enter="enviar"
                            ></v-text-field>
                        </v-flex>
                    </v-layout>
                </v-card-text>
            </v-form>
            <v-card-actions>
                <v-btn color="default" @click="setModalEnviarEmailOrcamento(false)" :loading="$store.getters.getOverlay" outlined>Voltar</v-btn>
                <v-spacer></v-spacer>
                <v-btn color="success" @click="enviar" :loading="$store.getters.getOverlay" outlined>Enviar</v-btn>
            </v-card-actions>
        </v-card>
    </v-dialog>
</template>
<script>
    import { mapGetters, mapActions } from 'vuex'
    export default {
        data(){
            return{
                email: '',
                rules: {
                    email: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                    tipoImpressao: [
                        v => !!v || 'Campo obrigatório.'
                    ],
                },
                tiposImpressao: [
                    { 
                        value: 'propostaA4',
                        label: 'Modelo proposta A4'
                    },
                    { 
                        value: 'orcamentoa4',
                        label: 'Modelo orçamento A4'
                    }
                ],
                tipoImpressao: 'propostaA4',
            }
        },
        computed: {
            ...mapGetters([
                'getModalEnviarEmailOrcamento',
                'getContato',
                'getOrcamento'
            ]),
            
        },
        methods: {
            ...mapActions([
                'enviarEmailOrcamento',
                'setModalEnviarEmailOrcamento'
            ]),
            enviar(){
                if(this.$refs.form.validate()){
                    this.enviarEmailOrcamento({
                        orcamento_id: this.getOrcamento.id,
                        email: this.email,
                        orcamento_tipo_impressao: this.tipoImpressao
                    })
                }
            }

        },
        created(){
            if(this.getContato.email){
                this.email = this.getContato.email
            }
        }

    }
</script>